// extracted by mini-css-extract-plugin
export default {"deletedCommentAuthorLink":"CommentDeletedEvent-module__deletedCommentAuthorLink__CsizB2I"};